/** AU site-specific P1 subscription cards for /p1-subscriptions?siteId=… */

export const P1_SIGNUP_BASE_URL =
  "https://my.priorityonewashclub.com/signup?productId=";

/** Partner company: CCW Subscriptions QR (not P1 Internal). */
export const CCW_SUBSCRIPTIONS_QR_PARTNER_ID = "6a8d536338c01c723ba8ff27";

/** Partner user under CCW Subscriptions QR. */
export const CCW_SUBSCRIPTIONS_QR_PARTNER_USER_ID = "6a8d53fb38c01c723ba9064c";

/** 6-month lock-in passed to P1 signup (per-signup override on existing products). */
export const SITE_CATALOG_LOCK_IN_MONTHS = 6;

/**
 * Default UTM for CCW site QR / p1-subscriptions catalog.
 * Overridden by utm_* already present on the CCW page URL.
 * Do not reuse for /subscriptions booking-flow signups.
 */
export const CCW_P1_SUBSCRIPTIONS_UTM = {
  utm_source: "ccw",
  utm_medium: "qr",
  utm_campaign: "ccw_p1_subscriptions",
};

/** Default UTM for /subscriptions booking-flow checkout into P1. */
export const CCW_BOOKING_FLOW_UTM = {
  utm_source: "CCW Booking",
  utm_medium: "ccw_subscriptions",
  utm_campaign: "ccw_booking",
};

/**
 * Locked key/token signup URLs under partner "CCW Subscriptions QR".
 * Pricing / lock-in / paidMonthly are baked into the SelfSignUpLink.
 * Sparkle uses open productId + partnerId (variant pricing by vehicle).
 */
export const AU_SITE_P1_SUBSCRIPTIONS = [
  {
    id: "sparkle",
    displayName: "Sparkle",
    pricingModel: "variant",
    p1ProductId: "68be9ff4c97473acf124ce94",
    partnerId: CCW_SUBSCRIPTIONS_QR_PARTNER_ID,
    partnerUserId: CCW_SUBSCRIPTIONS_QR_PARTNER_USER_ID,
    vehiclePricing: {
      sedan: 49,
      wagon: 59,
      "4wd": 69,
    },
    popular: true,
    features: [
      "Exterior hand wash",
      "Wheel & tyre clean",
      "Windows & mirrors",
      "Unlimited visits",
    ],
  },
  {
    id: "unlimited-outside-sedan",
    displayName: "Unlimited Outside",
    vehicleLabel: "Sedan / Hatch",
    pricingModel: "fixed",
    p1ProductId: "6a8fa66e3002737f5879224f",
    monthlyPrice: 49,
    vehicleType: "sedan",
    signupUrl:
      "https://my.priorityonewashclub.com/signup?key=6aba08a0f5036659fc5f2229&token=6047b27739b23fcace2b3ee4f870abd7:c1e1d7a5971fd506:c93370dee9a47273bc7eb2a3b081233088b5d5c198ab911767f54af115a3cf4a&utm_source=ccw&utm_medium=qr&utm_campaign=ccw_p1_subscriptions&utm_content=unlimited-outside-6m-sedan",
    features: [
      "Exterior hand wash",
      "Wheel & tyre clean",
      "Windows & mirrors",
      "Unlimited visits",
      "6-month lock-in",
    ],
  },
  {
    id: "unlimited-outside-suv",
    displayName: "Unlimited Outside",
    vehicleLabel: "Wagon / SUV",
    pricingModel: "fixed",
    p1ProductId: "6a8fa6703002737f5879225b",
    monthlyPrice: 59,
    vehicleType: "wagon",
    signupUrl:
      "https://my.priorityonewashclub.com/signup?key=6aba08a0f5036659fc5f222e&token=dfc852114b2517a557540448c4f65555:16fd340f8a8d6cee:2d824df4b09c3fb689b1ff728df80511aaab2861e990837a463f46248af600e5&utm_source=ccw&utm_medium=qr&utm_campaign=ccw_p1_subscriptions&utm_content=unlimited-outside-6m-wagon",
    features: [
      "Exterior hand wash",
      "Wheel & tyre clean",
      "Windows & mirrors",
      "Unlimited visits",
      "6-month lock-in",
    ],
  },
  {
    id: "unlimited-outside-4wd",
    displayName: "Unlimited Outside",
    vehicleLabel: "4WD / 7 Seater",
    pricingModel: "fixed",
    p1ProductId: "6a8fa6713002737f58792267",
    monthlyPrice: 69,
    vehicleType: "4wd",
    signupUrl:
      "https://my.priorityonewashclub.com/signup?key=6aba08a0f5036659fc5f2233&token=165ee9bd1c3c33f39785d3f163afed4e:6feb7cd236d8d7f4:927aa8102ccd22cf1617980c73b8fd71e8f1b72d40a03467ef169533a0b3821e&utm_source=ccw&utm_medium=qr&utm_campaign=ccw_p1_subscriptions&utm_content=unlimited-outside-6m-4wd",
    features: [
      "Exterior hand wash",
      "Wheel & tyre clean",
      "Windows & mirrors",
      "Unlimited visits",
      "6-month lock-in",
    ],
  },
  {
    id: "unlimited-sedan",
    displayName: "Unlimited Inside and Out",
    vehicleLabel: "Sedan / Hatch",
    pricingModel: "fixed",
    p1ProductId: "663030331cb67c538a7b591a",
    monthlyPrice: 69,
    vehicleType: "sedan",
    signupUrl:
      "https://my.priorityonewashclub.com/signup?key=6aba089ff5036659fc5f221a&token=1228e54d0deccd9189df4e63650bd009:3a346f27cd149fbe:4641d07ba5895fb94857dc96c8f8f2b8252972a96cb8b88d2da8b799fa2fccdb&utm_source=ccw&utm_medium=qr&utm_campaign=ccw_p1_subscriptions&utm_content=unlimited-io-6m-sedan",
    features: [
      "Full interior & exterior wash",
      "Unlimited visits",
      "Vacuum & wipe down",
    ],
  },
  {
    id: "unlimited-suv",
    displayName: "Unlimited Inside and Out",
    vehicleLabel: "Wagon / SUV",
    pricingModel: "fixed",
    p1ProductId: "6630306e1cb67c538a7b5926",
    monthlyPrice: 79,
    vehicleType: "wagon",
    signupUrl:
      "https://my.priorityonewashclub.com/signup?key=6aba089ff5036659fc5f221f&token=371ebc999da60137d18ebcbf066f5ee0:0533f2a29d5c48b1:53166db93b28dc4789bbd6bde4a059751defeb11ad055d8bc3c95dcbb184e37a&utm_source=ccw&utm_medium=qr&utm_campaign=ccw_p1_subscriptions&utm_content=unlimited-io-6m-wagon",
    features: [
      "Full interior & exterior wash",
      "Unlimited visits",
      "Vacuum & wipe down",
    ],
  },
  {
    id: "unlimited-4wd",
    displayName: "Unlimited Inside and Out",
    vehicleLabel: "4WD / 7 Seater",
    pricingModel: "fixed",
    p1ProductId: "6630309e1cb67c538a7b592d",
    monthlyPrice: 89,
    vehicleType: "4wd",
    signupUrl:
      "https://my.priorityonewashclub.com/signup?key=6aba08a0f5036659fc5f2224&token=a7cf2df6daa56b408c038a316c6ab3ad:ec12e1f36a7b1ab9:fe0bada112881941363836adc8b15a94da95b2169f7daf9ce70cc2e6268aa9a6&utm_source=ccw&utm_medium=qr&utm_campaign=ccw_p1_subscriptions&utm_content=unlimited-io-6m-4wd",
    features: [
      "Full interior & exterior wash",
      "Unlimited visits",
      "Vacuum & wipe down",
    ],
  },
];
